import React, { useEffect, useState } from 'react';
import { adminFetch, fmtNum } from './api';
import { PageHeader, EmptyState, ErrorBlock, Section, ScrollTable } from './widgets';

export default function AdminClicks() {
  const [byDemo, setByDemo] = useState(null);
  const [byIndustry, setByIndustry] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => { document.title = 'Sudco Admin — Showcase clicks'; }, []);

  const load = async () => {
    setError(null);
    try {
      const [d, i] = await Promise.all([
        adminFetch('/api/admin-stats/by-demo-slug'),
        adminFetch('/api/admin-stats/by-industry'),
      ]);
      setByDemo(d); setByIndustry(i);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => { load(); }, []);

  if (error) return <ErrorBlock error={error} onRetry={load} />;
  if (!byDemo || !byIndustry) return <div className="text-text-muted">Loading…</div>;

  return (
    <>
      <PageHeader title="Showcase clicks" subtitle="Engagement on /demos/<slug>?from=<prospect_id> links." />

      <Section title="By demo">
        {byDemo.rows.length === 0 ? (
          <EmptyState title="No clicks tracked yet" hint="Cold-email links carry ?from=<prospect_id> — once recipients click, they show up here." />
        ) : (
          <ScrollTable>
            <table className="w-full text-sm">
              <thead className="bg-surface-2 text-text-muted text-xs uppercase tracking-wide sticky top-0 z-10">
                <tr>
                  <th className="text-left px-4 py-2.5 font-medium">Demo slug</th>
                  <th className="text-right px-4 py-2.5 font-medium">Total views</th>
                  <th className="text-right px-4 py-2.5 font-medium">Unique prospects</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {byDemo.rows.map((r) => (
                  <tr key={r.demo_slug || '_none'} className="hover:bg-surface-2/40">
                    <td className="px-4 py-2.5 text-text">{r.demo_slug}</td>
                    <td className="px-4 py-2.5 text-right text-text">{fmtNum(r.total_views)}</td>
                    <td className="px-4 py-2.5 text-right text-text">{fmtNum(r.unique_prospects)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ScrollTable>
        )}
      </Section>

      <Section title="By industry">
        {byIndustry.rows.length === 0 ? (
          <EmptyState title="No industry data yet" />
        ) : (
          <ScrollTable>
            <table className="w-full text-sm">
              <thead className="bg-surface-2 text-text-muted text-xs uppercase tracking-wide sticky top-0 z-10">
                <tr>
                  <th className="text-left px-4 py-2.5 font-medium">Industry</th>
                  <th className="text-right px-4 py-2.5 font-medium">Total</th>
                  <th className="text-right px-4 py-2.5 font-medium">Sent</th>
                  <th className="text-right px-4 py-2.5 font-medium">Replied</th>
                  <th className="text-right px-4 py-2.5 font-medium">Bounced</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border">
                {byIndustry.rows.map((r) => (
                  <tr key={r.industry} className="hover:bg-surface-2/40">
                    <td className="px-4 py-2.5 text-text">{r.industry}</td>
                    <td className="px-4 py-2.5 text-right text-text-muted">{fmtNum(r.total)}</td>
                    <td className="px-4 py-2.5 text-right text-text">{fmtNum(r.sent)}</td>
                    <td className="px-4 py-2.5 text-right text-emerald-400">{fmtNum(r.replied)}</td>
                    <td className="px-4 py-2.5 text-right text-amber-400">{fmtNum(r.bounced)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ScrollTable>
        )}
      </Section>
    </>
  );
}
